import TicketIcon from '@material-design-icons/svg/filled/confirmation_number.svg?react';
import GroupIcon from '@material-design-icons/svg/filled/group.svg?react';
import HomeIcon from '@material-design-icons/svg/filled/home.svg?react';
import VerifiedUserIcon from '@material-design-icons/svg/filled/verified_user.svg?react';
import type { ComponentType } from 'react';
import { Link, useLocation } from 'react-router';

const ADMIN_LINKS: Array<{
  to: string;
  label: string;
  icon: ComponentType<{ className?: string }>;
  match: (pathname: string) => boolean;
}> = [
  {
    to: '/admin',
    label: 'Overview',
    icon: HomeIcon,
    match: (pathname) => pathname === '/admin' || pathname === '/admin/',
  },
  {
    to: '/admin/users',
    label: 'Users',
    icon: GroupIcon,
    match: (pathname) =>
      pathname === '/admin/users' || pathname === '/admin/users/',
  },
  {
    to: '/admin/kyb',
    label: 'KYC/KYB',
    icon: VerifiedUserIcon,
    match: (pathname) =>
      pathname === '/admin/kyb' || pathname === '/admin/kyb/',
  },
  {
    to: '/admin/invites',
    label: 'Invites',
    icon: TicketIcon,
    match: (pathname) =>
      pathname === '/admin/invites' || pathname === '/admin/invites/',
  },
];

export function AdminNav() {
  const location = useLocation();

  return (
    <div className="border-b border-neutral-700 bg-neutral-900/50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <nav className="flex gap-x-1 py-4 overflow-x-auto whitespace-nowrap scrollbar-hide">
          {ADMIN_LINKS.map((link) => {
            const Icon = link.icon;
            const isActive = link.match(location.pathname);

            return (
              <Link
                key={link.to}
                to={link.to}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-neutral-800 text-white'
                    : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
                }`}
              >
                <Icon className="fill-current size-4" />
                {link.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
